import { render, staticRenderFns } from "./main_header.vue?vue&type=template&id=0d56cd02"
import script from "./main_header.vue?vue&type=script&lang=js"
export * from "./main_header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports